import React from 'react';

const IdentifyLayerInfoPlaceholder = () => (
  <div className="placeholder__bottom-space">
    <div className="text__placeholder placeholder__top-space placeholder__bottom-space shimmer" />
    <div className="text__placeholder--medium placeholder__bottom-space shimmer" />
    <div className="text__placeholder--small placeholder__bottom-space shimmer" />
  </div>
);

export default IdentifyLayerInfoPlaceholder;
